import env from "../env"

export interface ItemDetailUrlData {
    workspaceId?: number
    listId?: string
    itemId: number
    extra?: string[]
}

export const setQueryParam = (key: string, value?: string): void => {
    // https://caniuse.com/urlsearchparams
    const urlSplits = window.location.href.split("?")
    const params = new URLSearchParams(urlSplits.length > 1 ? urlSplits[1] : "")

    if (!!value) {
        params.set(key, value)
    } else {
        params.delete(key)
    }

    const queryParams =
        params.toString().length > 0 ? `?${params.toString()}` : ""
    window.history.replaceState({}, "", `${urlSplits[0]}${queryParams}`)
}

export const hasQueryParam = (key: string): boolean => {
    // https://caniuse.com/urlsearchparams
    const urlSplits = window.location.href.split("?")
    const params = new URLSearchParams(urlSplits.length > 1 ? urlSplits[1] : "")
    return params.has(key)
}

export const getQueryParam = (key: string): string | null => {
    // https://caniuse.com/urlsearchparams
    const urlSplits = window.location.href.split("?")
    const params = new URLSearchParams(urlSplits.length > 1 ? urlSplits[1] : "")
    return params.get(key)
}

export const removeQueryParam = (key: string): void => {
    setQueryParam(key)
}

/**
 * Parses the current URL and returns an `ItemDetailUrlData` object.
 *
 * @return {ItemDetailUrlData} An object containing the parsed URL data.
 * @throws {Error} If the URL is invalid.
 * @throws {Error} If the item ID or the workspace ID is not a number.
 */
export const parseItemDetailUrl = (
    url = window.location.href,
): ItemDetailUrlData => {
    const urlParts = url.split("/")

    const basePath = env.applicationPath
    const basePathParts = basePath.split("/")

    // Remove the basePath parts from urlParts
    // Example: https://localhost:5001/Item/123 -> [Item, 123]
    // Example: https://localhost:5001/Robinson/Workspace/123/123l/123 -> [Workspace, 123, 123l, 123]
    urlParts.splice(0, basePathParts.length + 2)

    const parsedUrl: ItemDetailUrlData = {
        itemId: -1,
    }

    if (urlParts[0] === "workspace") {
        parsedUrl.workspaceId = parseInt(urlParts[1])
        parsedUrl.listId = urlParts[2]
        parsedUrl.itemId = parseInt(urlParts[3])
        if (urlParts.length > 4) {
            parsedUrl.extra = urlParts.slice(4)
        }
    } else if (urlParts[0] === "item") {
        parsedUrl.itemId = parseInt(urlParts[1])
        if (urlParts.length > 2) {
            parsedUrl.extra = urlParts.slice(2)
        }
    } else if (urlParts[0] === "dashboard") {
        parsedUrl.itemId = parseInt(urlParts[2])
    }
    if (
        isNaN(parsedUrl.itemId) ||
        parsedUrl.itemId === -1 ||
        (parsedUrl.workspaceId !== undefined && isNaN(parsedUrl.workspaceId))
    ) {
        throw new Error("Invalid URL")
    }

    return parsedUrl
}
